import { render } from "./ServicesTab.vue?vue&type=template&id=a2ed0f52&scoped=true"
import script from "./ServicesTab.vue?vue&type=script&lang=js"
export * from "./ServicesTab.vue?vue&type=script&lang=js"

import "./ServicesTab.vue?vue&type=style&index=0&id=a2ed0f52&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ed0f52"]])

export default __exports__